import DeviceConfig from '@devices/config';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

interface Props {
  opacity?: number;
}

const BackgroundMask = styled.div<Props>`
  position: fixed;
  backdrop-filter: ${DeviceConfig?.capabilities?.disableBlur
    ? ''
    : `blur(${25 * Screen.widthRatio}px)`};
  background: ${(props) => 'rgba(0,0,0,' + (props.opacity || 0.9) + ')'};
  top: 0;
  left: 0;
  width: ${1920 * Screen.widthRatio}px;
  height: ${1080 * Screen.widthRatio}px;
`;

export default BackgroundMask;
